// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"DropdownPlain_dropdown_1Cofjh9","dropdownTrigger":"DropdownPlain_dropdownTrigger_2wv9BV9","dropdownIcon":"DropdownPlain_dropdownIcon_1Hi_ym5"};